import PlannedNotifyForm from "./PlannedNotifyForm";
import React from "react";
import OffersGrid from "./OffersGrid";
import InfoModal from "./InfoModal";
import Pin from "../assets/icons/svg/map-pin-line.svg";
import { GlobalContext } from "../globalContext";
import { useContext, useState } from "react";
import CheckBlue from "../assets/icons/svg/check-line-blue.svg";
import ArrowDown from "../assets/icons/svg/arrow-down.svg";
import { endpoints, apiClient } from "../utils/constants";
import { trackEvent } from "../utils/gtmTracker"; 



export default function ResultCard({ variant = "coveredFtth" }) {
  
  const { store, resetStore, updateStore, t } = useContext(GlobalContext);

  const variantsCopy = {
    
    coveredFtth: { 
      sub: t.coveredCTA,
      caption: t.coveredSubTitle
    },
    coveredFiberstream: {
      sub: t.uncoveredCTA,
      caption: t.uncoveredSubTitle
    },

    fttc_arrivingFtth: { 
      sub: t.arrivingCTA,
      caption: t.arrivingSubTitle
    },
    
    fttc_notArrivingFtth: { 
      sub: t.uncoveredCTA,
      caption: t.uncoveredSubTitle
    },

    no_network: {
      sub: t.noNetworkCTA,
      caption: t.noNetworkSubTitle
    },

    fttc_planned: { //non usato
      sub: t.fttcPlannedCTA,
      caption: t.fttcPlannedSubTitle
    },
  };

  
  const { sub, caption } = variantsCopy[variant];
  const [ hasSubmitted, setHasSubmitted] = useState(false);
  const [ submissionError, setSubmissionError] = useState(false);  
  const [ segment, setSegment ] = useState("privati");
  const [ fiberstreamFttcSegment, setFiberstreamFttcSegment ] = useState("privati");
  const [ fiberstreamFtthSegment, setFiberstreamFtthSegment ] = useState("privati");
  const [ speedFilter, setSpeedFilter ] = useState("Non Attivo");



  // Gestore per cambio filtro velocità (desktop e mobile)
  function handleSpeedFilterChange(newSpeed) {
    setSpeedFilter(newSpeed);
    // Tracciamento evento cambio filtro velocità
    trackEvent("filter_change_velocity", {
      indirizzo: store.selectedAddress || "",
      velocity: newSpeed
    });
  }

  const nervousChangeCount = React.useRef(0);
  const nervousChangeTimer = React.useRef(null);

  // Tracking cambio filtro segment con tracciamento nervoso
  function handleSegmentChange(newSegment, target = "default") {
    trackEvent("filter_change", { indirizzo: store.selectedAddress || "" });

    if (variant === "coveredFiberstream") {
      if (target === "fiberstreamFttc") {
        setFiberstreamFttcSegment(newSegment);
      } else if (target === "fiberstreamFtth") {
        setFiberstreamFtthSegment(newSegment);
      } else {
        setSegment(newSegment);
      }
    } else {
      setSegment(newSegment);
    }

    nervousChangeCount.current += 1;

    // Reset timer if già attivo
    if (nervousChangeTimer.current) {
      clearTimeout(nervousChangeTimer.current);
    }
    nervousChangeTimer.current = setTimeout(() => {
      nervousChangeCount.current = 0;
      nervousChangeTimer.current = null;
    }, 5000); // 5 secondi

    if (nervousChangeCount.current >= 3) {
      trackEvent("filter_change_nervous", {
        indirizzo: store.selectedAddress || "",
        rapidChangeCount: nervousChangeCount.current,
      });
      nervousChangeCount.current = 0;
      clearTimeout(nervousChangeTimer.current);
      nervousChangeTimer.current = null;
    }
  }



  // Tracciamento e reset per back desktop
  function handleDesktopBackClick() {
    if (store.selectedAddress) {
      trackEvent("another_request_click", { indirizzo: store.selectedAddress });
    } else {  
      trackEvent("another_request_click");
    }
    resetStore();
  }
 

  // Gestione discriminante per no_coverage vs no_network
  const handleNoCoverageInterest = (variantType) => {
    const payload = {
      nome: "",
      cognome: "",
      email: "",
      codiceTopCliente: store.selectedCodeTopClient || "",
      comune: store.selectedAddress || "",
      type: variantType
    };

    apiClient
      .post(endpoints.subscribeEmailFromNewsletter, payload, false, true)
      .then(() => {
        
        trackEvent("noCoverageInterest_submit", {
          indirizzo: payload.comune,
          codiceTopCliente: payload.codiceTopCliente,
          tipoInteresse: variantType
        });

        setSubmissionError(false); // <-- successo
        setHasSubmitted(true);
      })
      .catch((error) => {
        console.error("[noCoverageInterest] Errore invio:", error);
        let errorMessage = error?.message || 'unknown error';
        let statusCode = error?.response?.status;
        let errorString = '';
        if (statusCode) {
          errorString = `${statusCode}: ${errorMessage}`;
        } else {
          errorString = `Code not available: ${errorMessage}`;
        }
        trackEvent("noCoverageInterest_submit_error", {
          noCoverageInterest_submit_error: errorString,
          indirizzo: payload.comune,
          codiceTopCliente: payload.codiceTopCliente,
          tipoInteresse: variantType
        });

        setHasSubmitted(true);
        setSubmissionError(true);  // <-- errore
      });
  };



 

  return (
   <>
      <div className="result-info">
        {variant === "fttc_planned" ? (
          <div className="offers-header fttc-arriving-header">
            <div className="offers-header__left">
              <p className="result-status fttc_planned">
                <span>{t.fttcPlannedCTA}</span>
              </p>
            </div>
            <div className="offers-header__center"/>
            <div className="offers-header__right">
              <button
                className="back-button rp-desktop-only"
                onClick={handleDesktopBackClick}
              >
                <p>{t.anotherRequest}</p>
              </button>
            </div>
          </div>
        ) : (
          <>
            <div>
              <p className="result-sub-text">{sub}</p>
              <p className="result-caption-text">{caption}</p>
            </div>
            <div>{/*className="result-actions-desktop"*/}
              <button
                className="back-button rp-desktop-only"
                onClick={handleDesktopBackClick}
              >
                <p>{t.anotherRequest}</p>
              </button>

              {/* Filtro segment e velocità solo se ci sono offerte */}
              {variant === "coveredFtth" || variant === "coveredFiberstream" || variant === "fttc_arrivingFtth" || variant === "fttc_notArrivingFtth" ? (
                <>
                  <div className="select-wrapper rp-desktop-only">
                    <img src={ArrowDown} alt="arrow icon" className="arrow-icon" />
                    <select
                      value={variant === "coveredFiberstream" ? fiberstreamFttcSegment : segment}
                      onChange={(e) => handleSegmentChange(e.target.value, variant === "coveredFiberstream" ? "fiberstreamFttc" : "default")}
                      className="select-input"
                    >
                      <option value="privati">{t.filterPrivate}</option>
                      <option value="pmi">{t.filters}</option>
                    </select>
                  </div>

                  {variant === "coveredFtth" && (
                    <div className="select-wrapper rp-desktop-only" style={{ marginTop: 8 }}>
                      <img src={ArrowDown} alt="arrow icon" className="arrow-icon" />
                      <select
                        value={speedFilter}
                        onChange={e => handleSpeedFilterChange(e.target.value)}
                        className="select-input"
                      >
                        <option value="Non Attivo">{t.filterVelocity}</option>
                        <option value="1G">1G</option>
                        <option value="2,5G">2,5G</option>
                        <option value="5G">5G</option>
                        <option value="10G">10G</option>
                      </select>
                    </div>
                  )}
                </>
              ) : null}
            </div>
          </>
        )}
      </div>
          
        
    
      {(variant === "no_network" || variant === "fttc_planned") && (
        <>
          <div className="offers-header__mobile-actions rp-mobile-only" style={{ marginBottom: 16 }}>
            <button className="back-button" onClick={handleDesktopBackClick}>
              <p>{t.anotherRequest}</p>
            </button>
          </div>
        </>
      )}

      {/* Sezione offerte solo per coveredFtth e fttc_arrivingFtth */}
      {(variant === "coveredFtth" || variant === "fttc_arrivingFtth" || variant === "fttc_notArrivingFtth") && (
        <OffersGrid
          techFilter={variant === "coveredFtth" ? "FTTH" : "FTTC"}
          variant={variant}
          segment={segment}
          onChangeSegment={handleSegmentChange}
          speedFilter={speedFilter}
          onChangeSpeedFilter={handleSpeedFilterChange}
        />
      )}

      {/* FTTC_NOT_ARRIVING_FTTH: mostra componente per manifesta interesse */}
      {variant === "fttc_notArrivingFtth" && (
        <div className="result-contact">
          <div className="result-contact-flex">
            {hasSubmitted && (
              <img
                src={CheckBlue}
                alt="icon"
                className="result-contact-icon"
              />
            )}
            <p className="result-contact-text">
              {hasSubmitted ? (
                submissionError
                ? t.uncoveredSubmissionError : t.uncoveredSubmissionSuccess
              ) : (
                t.uncoveredRequestInfo
              )}
            </p>
          </div>
          {!hasSubmitted && (
            <button
              className="result-contact-button"
              onClick={() => handleNoCoverageInterest("FTTH_NON_ATTIVO_FTTC_ATTIVO")}
            >
              {t.clickHere}
            </button>
          )}
        </div>
      )}

      {/* FTTC_PLANNED: mostra direttamente InfoModal (come notifyme) */}
        {variant === "fttc_planned" && (
          <div className="fttc_planned">
            {store.selectedAddress && (
              <>
                <div className="selected-address-row">
                  <img src={Pin} alt="" className="selected-address-icon" />
                  <span className="selected-address-text">{store.selectedAddress}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
                  <PlannedNotifyForm variantType="FTTH_NON_ATTIVO_FTTC_PIANIFICATO" />
                </div>
              </>
            )}
          </div>
        )}



      {/* NO_NETWORK: solo componente consenso, nessuna card offerte */}
        {variant === "no_network" && (
          <div className="no_network">
            {store.selectedAddress && (
              <div className="selected-address-row">
                <img src={Pin} alt="" className="selected-address-icon" />
                <span className="selected-address-text">{store.selectedAddress}</span>
              </div>
            )}
            <div className="result-contact no-network-interest-wrapper">
              {hasSubmitted ? (
                <>
                  <div className="result-contact-flex" style={{ justifyContent: 'center' }}>
                    <img
                      src={CheckBlue}
                      alt="icon"
                      className="result-contact-icon"
                    />
                    <p className="result-contact-text">
                      {submissionError ? t.uncoveredSubmissionError : t.uncoveredSubmissionSuccess}
                    </p>
                  </div>
                </>
              ) : (
                <>
                  <div className="no-network-interest-texts">
                    <p className="result-contact-text no-network-interest-line">{t.noNetworkInterestLine1}</p>
                    <p className="result-contact-text no-network-interest-line">{t.noNetworkInterestLine2}</p>
                  </div>
                  <button
                    className="result-contact-button no-network-interest-button"
                    onClick={() => handleNoCoverageInterest("FTTH_NON_ATTIVO_FTTC_NON_ATTIVO")}
                  >
                    {t.noNetworkInterestButton}
                  </button>
                </>
              )}
            </div>
          </div>
        )}

        {/* COVERED_FIBERSTREAM: mostra le offerte Fiberstream */}
          {variant === "coveredFiberstream" && (
          <>
            <OffersGrid
              techFilter="FTTC"
              variant="fttc_notArrivingFtth"
              segment={fiberstreamFttcSegment}
              onChangeSegment={(newSegment) => handleSegmentChange(newSegment, "fiberstreamFttc")}
              speedFilter={speedFilter}
              onChangeSpeedFilter={handleSpeedFilterChange}
              showDisclaimer={false}
            />

            <div className="result-contact">
              <div className="result-contact-flex">
                {hasSubmitted && (
                  <img
                    src={CheckBlue}
                    alt="icon"
                    className="result-contact-icon"
                  />
                )}
                <p className="result-contact-text">
                  {hasSubmitted ? (
                    submissionError
                      ? t.uncoveredSubmissionError
                      : t.uncoveredSubmissionSuccess
                  ) : (
                    t.uncoveredRequestInfo
                  )}
                </p>
              </div>
              {!hasSubmitted && (
                <button
                  className="result-contact-button"
                  onClick={() => handleNoCoverageInterest("FTTH_ATTIVO_FIBERSTREAM")}
                >
                  {t.clickHere}
                </button>
              )}
            </div>

            <div className="result-info" style={{ marginTop: 24 }}>
              <div>
                <p className="result-sub-text fiberstream-ftth-title">{t.fiberstreamFtthCTA}</p>
                {/* coveredSubTitle commentato: già mostrato nella prima dashboard, inutile ripeterlo */}
                {/* <p className="result-caption-text">{t.coveredSubTitle}</p> */}
              </div>
              <div>  {/*//className="result-actions-desktop">*/}
                <button
                  className="back-button rp-desktop-only"
                  onClick={handleDesktopBackClick}
                >
                  <p>{t.anotherRequest}</p>
                </button>
                <div className="select-wrapper rp-desktop-only">
                  <img src={ArrowDown} alt="arrow icon" className="arrow-icon" />
                  <select
                    value={fiberstreamFtthSegment}
                    onChange={(e) => handleSegmentChange(e.target.value, "fiberstreamFtth")}
                    className="select-input"
                  >
                    <option value="privati">{t.filterPrivate}</option>
                    <option value="pmi">{t.filters}</option>
                  </select>
                </div>
              </div>
            </div>
            <OffersGrid
              techFilter="FTTH"
              variant="coveredFtth"
              segment={fiberstreamFtthSegment}
              onChangeSegment={(newSegment) => handleSegmentChange(newSegment, "fiberstreamFtth")}
              speedFilter={speedFilter}
              onChangeSpeedFilter={handleSpeedFilterChange}
              showStatus={false}
              hideOffersCount={true}
            />
          </>
          )}

        {store.notifyModalOpen && (
          <InfoModal onClose={() => updateStore({ notifyModalOpen: false })} />
        )}



    </>
  );
}
